var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 16.6666C13.6818 16.6666 16.6665 13.6819 16.6665 9.99996C16.6665 6.31806 13.6818 3.33329 9.99984 3.33329C6.31794 3.33329 3.33317 6.31806 3.33317 9.99996C3.33317 13.6819 6.31794 16.6666 9.99984 16.6666ZM9.99984 18.3333C14.6022 18.3333 18.3332 14.6023 18.3332 9.99996C18.3332 5.39758 14.6022 1.66663 9.99984 1.66663C5.39746 1.66663 1.6665 5.39758 1.6665 9.99996C1.6665 14.6023 5.39746 18.3333 9.99984 18.3333Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 8.33337C9.99984 7.87314 10.3729 7.50004 10.8332 7.50004H11.6665C12.1268 7.50004 12.4998 7.12695 12.4998 6.66671C12.4998 6.20647 12.1268 5.83337 11.6665 5.83337H10.8332C9.45242 5.83337 8.33317 6.95267 8.33317 8.33337V10H7.49984C7.0396 10 6.6665 10.3731 6.6665 10.8334C6.6665 11.2936 7.0396 11.6667 7.49984 11.6667H8.33317V16.6667C8.33317 17.127 8.70625 17.5 9.1665 17.5C9.62675 17.5 9.99984 17.127 9.99984 16.6667V11.6667H11.6665C12.1268 11.6667 12.4998 11.2936 12.4998 10.8334C12.4998 10.3731 12.1268 10 11.6665 10H9.99984V8.33337Z",
    fill: "#777E91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.631be0aec639cb5794ad8ac1c24ba7a5.svg";
export { ForwardRef as ReactComponent };